import { Routes } from "@angular/router";
import { Environment as env } from "@amwager/util-ts";
import { accessGuardRouteFn } from "@amwager/data-access";
import { WagerComponent } from "./components/wager/wager.component";



export const originalRoutes: Routes = [
  {
    path: 'wager',
    component: WagerComponent,
    canActivate: [accessGuardRouteFn],
    title: 'Wager',
  },
];

export const testRoutes: Routes = [
  {
    path: 'wager/test',
    component: WagerComponent,
    title: 'Wager',
  },
];

export const routes: Routes = env.Environment.enableComponentView
  ? [ ...originalRoutes, ...testRoutes ]
  : [ ...originalRoutes ]
;
